import {useState, useEffect} from 'react';
import { Box, TextField, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { showModal } from 'react-redux-modal-provider';
import ModalBuscadorV2 from '../../modals/default/ModalBuscadorV2';

const InputSearchNavV2 = ({value,disabled,onChange,isClearable,errorText, ...props}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    const [textSearch, setTextSearch] = useState('');

    useEffect(() => {
        if(textSearch && textSearch.length > 2){
            showModal(ModalBuscadorV2,{textSearch: textSearch})
        }
    }, [textSearch])

    return (
        <Box sx={{width:350,display: 'flex',pt: 0.5,pb:0.5}}>
            <TextField
                onChange={(e)=>setTextSearch(e.target.value)}
                value={textSearch}
                placeholder='Buscar...'
                fullWidth
                autoComplete='off'
                InputProps={{
                    style:{ 
                        fontWeight: 'normal',
                        fontSize:15,
                        color: isDarkMode ? '#e0e0e0' : '#15294b',
                        backgroundColor: isDarkMode ? '#2d3a52' : '#ffffff'
                    },
                    type: 'search',
                    startAdornment:(
                        <SearchIcon sx={{color: isDarkMode ? '#90a4ae' : '#6b7280',opacity: 0.9,marginTop:-0.7}} size={20} />
                    )
                }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: isDarkMode ? '#2d3a52' : '#ffffff',
                        borderRadius: 3,
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: isDarkMode ? '#64B5F6' : '#6b7280',
                            borderWidth: '1px',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: isDarkMode ? '#64B5F6' : '#b3b9c4',
                            borderWidth: '1px',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: isDarkMode ? '#64B5F6' : '#0364ff',
                            borderWidth: '2px',
                        },
                    },
                    '& input':{
                        marginTop: -0.9,
                        pb: 1.5,
                        marginLeft:1,
                        color: `${isDarkMode ? '#e0e0e0' : '#15294b'} !important`,
                        '&::placeholder': {
                            color: `${isDarkMode ? '#90a4ae' : '#6b7280'} !important`,
                            opacity: '1 !important'
                        },
                        '&::-webkit-input-placeholder': {
                            color: `${isDarkMode ? '#90a4ae' : '#6b7280'} !important`,
                            opacity: '1 !important'
                        },
                        '&::-moz-placeholder': {
                            color: `${isDarkMode ? '#90a4ae' : '#6b7280'} !important`,
                            opacity: '1 !important'
                        }
                    }
                }}
            />
        </Box>
    );
};

InputSearchNavV2.defaultProps = {
    isClearable: false,
    value: null
};

export default InputSearchNavV2;